import { render, staticRenderFns } from "./VenueInfoSection.vue?vue&type=template&id=6df78efc&scoped=true"
import script from "./VenueInfoSection.vue?vue&type=script&lang=js"
export * from "./VenueInfoSection.vue?vue&type=script&lang=js"
import style0 from "./VenueInfoSection.vue?vue&type=style&index=0&id=6df78efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df78efc",
  null
  
)

export default component.exports